import { render } from "./CardView.vue?vue&type=template&id=065bef49&scoped=true"
import script from "./CardView.vue?vue&type=script&lang=js"
export * from "./CardView.vue?vue&type=script&lang=js"

import "./CardView.vue?vue&type=style&index=0&id=065bef49&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-065bef49"]])

export default __exports__